import { DatePicker } from 'antd';
import React, { forwardRef } from 'react';

import { periodDisplayFormat } from './constants';

const { MonthPicker } = DatePicker;

export const ScheduleMonthPicker = forwardRef(function ScheduleMonthPicker(
  { className, disabled, id, name, onChange, onMonthChange, value },
  ref
) {
  const periodValue = Array.isArray(value) ? value : [];
  const selectedMonth = periodValue[0] || periodValue[1];

  const handleChange = (month) => {
    if (typeof onChange === 'function') {
      if (month) {
        const normalizedMonth = month.clone().startOf('month');

        onChange([normalizedMonth, normalizedMonth.clone()]);
        if (typeof onMonthChange === 'function') {
          onMonthChange(normalizedMonth);
        }
      } else {
        onChange(undefined);
        if (typeof onMonthChange === 'function') {
          onMonthChange(undefined);
        }
      }
    }
  };

  return (
    <MonthPicker
      ref={ref}
      className={className}
      format={periodDisplayFormat}
      id={id}
      name={name}
      placeholder="Месяц"
      value={selectedMonth}
      disabled={disabled}
      onChange={handleChange}
    />
  );
});
